<p class="title">Create a Custom Region</p>
<mpro-text-input
    title="Region name"
    info="Max 16 characters"
    [errorMsg]="noName ? 'Please enter a name for your custom region' : 'Max: 16 characters'"
    [(ngModel)]="region.name"
    (keyup)="regionNameKeyup()"
    [inputState]="inputState"
    placeholder=""
></mpro-text-input>
<mpro-text-input
    title="Select countries"
    placeholder= ""
    [(ngModel)]="searchTerm"
    (keyup)="searchTermKeyup()"
    (clear)="clearSearch()"
></mpro-text-input>
<div class="scrollable">
    <ng-container *ngFor="let c of getSortedCountries()">
      <mpro-checkable-dropdown-item
        [disabled]="!!c.authDisabled"
        [showLock]="!!c.authDisabled"
        [leftText]="c.name"
        [checked]="selectedCountries.has(c.code) || false"
        (itemChecked)="onCountrySelected($event, c)"
        ></mpro-checkable-dropdown-item>
    </ng-container>
</div>
<p class="subtitle">{{ selectedCountries.size === 0 ? 'No' : selectedCountries.size }} {{selectedCountries.size === 1 ? 'country' : 'countries'}} selected</p>
<div class="buttons">
    <button class="mpro-btn mpro-btn-secondary" (click)="cancelClick()" stopClickPropagation>
        Cancel
    </button>
    <button class="mpro-btn mpro-btn-primary" [disabled]="selectedCountries.size === 0" (click)="saveClick()" stopClickPropagation>
        Save
    </button>
</div>
